<template>
  <div>
  </div>
</template>
<script>
import API from "../../api/api";
export default {
  data() {
    return {
      empty: false,
      routeList:this.$route.meta.routeList
    }
  },
  methods: {
  },
  mounted() {
     this.$router.push({
          name: this.routeList[0].name
        });
  }
};
</script>


// WEBPACK FOOTER //
// src/views/platform/routeEmptyeba.vue